function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { GALLERY_CONSTS, NEW_PRESETS, utils } from 'pro-gallery-lib';
import { formatLeanGalleryStyles } from './leanGallery'; //example: http://pro-gallery.surge.sh/?titlePlacement=DONT_SHOW&itemClick=nothing&allowHover=false&galleryLayout=2&allowLeanGallery=true

export var notEligibleReasons = function notEligibleReasons(_ref) {
  var items = _ref.items,
      styles = _ref.styles;

  var s = _objectSpread(_objectSpread(_objectSpread({}, styles), NEW_PRESETS.grid), {}, {
    allowLeanGallery: true
  });

  var res = [];

  if (String(styles.galleryLayout) !== '2') {
    res.push('not a Grid layout');
  }

  if (items.length > MAX_ITEMS_COUNT) {
    res.push("more than " + MAX_ITEMS_COUNT + " items");
  }

  var nonImagesCount = 0;

  for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
    var item = _step.value;

    if (!isImage(item)) {
      nonImagesCount++;
    }
  }

  if (nonImagesCount > 0) {
    res.push(nonImagesCount + " items are not an image");
  }

  for (var _i = 0, _Object$entries = Object.entries(s); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        styleParam = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (!isValidStyleParam(styleParam, value, s)) {
      res.push("invalid style: " + styleParam + " => " + value);
    }
  }

  return res;
};
export default (function (_ref2) {
  var items = _ref2.items,
      styles = _ref2.styles;
  styles = formatLeanGalleryStyles(styles);
  var allowLeanGallery = !!styles.allowLeanGallery;

  if (!allowLeanGallery) {
    return false;
  }

  if (items.length > MAX_ITEMS_COUNT) {
    utils.isVerbose() && console.log("[LEAN GALLERY] NOT ALLOWED - more than " + MAX_ITEMS_COUNT + " items", items.length);
    return false;
  }

  for (var _iterator2 = _createForOfIteratorHelperLoose(items), _step2; !(_step2 = _iterator2()).done;) {
    var item = _step2.value;

    if (!isImage(item)) {
      utils.isVerbose() && console.log("[LEAN GALLERY] NOT ALLOWED - an item that is not an image", item);
      return false;
    }
  }

  for (var _i2 = 0, _Object$entries2 = Object.entries(styles); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _Object$entries2[_i2],
        styleParam = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];

    if (!isValidStyleParam(styleParam, value, styles)) {
      utils.isVerbose() && console.log("[LEAN GALLERY] NOT ALLOWED - invalid styleParam", styleParam, value);
      return false;
    }
  }

  utils.isVerbose() && console.log("[LEAN GALLERY] ALLOWED!", styles);
  return true;
});
var MAX_ITEMS_COUNT = 25;

var isImage = function isImage(item) {
  var meta = item.metadata || item.metaData;
  var isImageItem = !!((!meta.type || meta.type === 'image') && (item.url || item.mediaUrl || item.src));
  return isImageItem;
};

var isValidStyleParam = function isValidStyleParam(styleParam, value, allStyles) {
  if (typeof handledStyleParams[styleParam] !== 'undefined') return true; // if (typeof ignoredStyleParams[styleParam] !== 'undefined') return true;

  if (typeof fixedStyleParams[styleParam] !== 'undefined') {
    var sp = fixedStyleParams[styleParam];

    if (sp && typeof sp === 'function') {
      return sp(allStyles);
    } else if (sp && sp.length > 0) {
      return sp.includes(value);
    } else {
      return sp === value;
    }
  }

  return true;
}; //these styles can get any value, the lean gallery will handle them


var handledStyleParams = {
  numberOfImagesPerRow: 3,
  gallerySizeType: 'smart',
  gallerySizeRatio: 1,
  gallerySizePx: 300,
  gallerySize: 30,
  cubeType: 'fill',
  cubeRatio: 1,
  fixedColumns: 0,
  borderRadius: 0,
  imageMargin: 10,
  gridStyle: 0,
  itemBorderWidth: 0,
  itemBorderRadius: 0,
  imageQuality: 90,
  textBoxHeight: 200
}; //these params are not relevant when a lean gallery is rendered - the fixed styles will override them

/*
const ignoredStyleParams = {
  gotStyleParams: true,
  galleryType: null,
  collageAmount: 0,
  numberOfImagesPerCol: 2,
  minItemSize: 120,
  chooseBestGroup: true,
  groupTypes: '1,2h,2v,3t,3b,3l,3r',
  collageDensity: 0.8, //80, // should be 0.8 after
  cropOnlyFill: false,
  gallerySliderImageRatio: 16 / 9,
  groupsPerStrip: 0,
  showArrows: false,
  viewMode: 'preview',
  thumbnailSpacings: 4,
  enableScroll: true,
  hasThumbnails: true,
  isGrid: false,
  isSlider: false,
  isColumns: false,
  isMasonry: false,
  isSlideshow: false,
  isAutoSlideshow: false,
  slideshowLoop: false,
  autoSlideshowInterval: 4,
  galleryTextAlign: 'center',
  scrollSnap: false,
  fullscreen: true,
  arrowsPosition: 0,
  arrowsSize: 23,
  defaultShowInfoExpand: 1,
  allowLinkExpand: true,
  expandInfoPosition: 0,
  allowFullscreenExpand: true,
  fullscreenLoop: false,
  galleryAlignExpand: 'left',
  slideshowInfoSize: 200,
  playButtonForAutoSlideShow: false,
  allowSlideshowCounter: false,
  galleryThumbnailsAlignment: 'bottom',
  thumbnailSize: 250,
  magicLayoutSeed: 1,
  textImageSpace: 10,
  textBoxBorderRadius: 0,
  textBoxBorderWidth: 0,
  loadMoreButtonText: '',
  loadMoreButtonBorderWidth: 1,
  loadMoreButtonBorderRadius: 0,
  itemShadowBlur: 20,
  itemShadowDirection: 135,
  itemShadowSize: 10,
  usm_a: 0,
  usm_r: 0,
  usm_t: 0,
  videoPlay: 'hover',
  videoSound: false,
  videoSpeed: '1',
  videoLoop: true,
  overlayAnimation: GALLERY_CONSTS.overlayAnimations.NO_EFFECT,
  watermarkOpacity: 40,
  watermarkSize: 40,
  useWatermark: false,
  watermarkDock: null,
  loadMoreAmount: 'all',
  addToCartBorderWidth: 1,
  imageLoadingMode: GALLERY_CONSTS.loadingMode.BLUR,
  hoveringBehaviour: GALLERY_CONSTS.infoBehaviourOnHover.APPEARS,
  expandAnimation: GALLERY_CONSTS.expandAnimations.NO_EFFECT,
  imageHoverAnimation: GALLERY_CONSTS.imageHoverAnimations.NO_EFFECT,
  selectedLayout: '',
  layoutsVersion: 2,
  selectedLayoutV2: 2,
  isSlideshowFont: false,
  addToCartButtonText: '',
  imageInfoType: GALLERY_CONSTS.infoType.NO_BACKGROUND,
  galleryImageRatio: 2,
  sharpParams: {},
  itemBorderColor: {},
};
*/
//these params must be set to these exact values in order for the lean gallery to render well

var fixedStyleParams = {
  allowLeanGallery: true,
  galleryLayout: [-1, 2],
  isVertical: true,
  oneRow: false,
  isRTL: false,
  scrollDirection: [0, undefined],
  groupSize: 1,
  hoveringBehaviour: [GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW, GALLERY_CONSTS.infoBehaviourOnHover.APPEARS],
  rotatingGroupTypes: '',
  cubeImages: true,
  smartCrop: false,
  rotatingCubeRatio: '',
  boxShadow: 0,
  galleryMargin: 0,
  floatingImages: 0,
  placeGroupsLtr: false,
  mobilePanorama: false,
  enableInfiniteScroll: [true, 1],
  itemEnableShadow: false,
  itemClick: [GALLERY_CONSTS.itemClick.NOTHING, GALLERY_CONSTS.itemClick.LINK, GALLERY_CONSTS.itemClick.FULLSCREEN, GALLERY_CONSTS.itemClick.EXPAND],
  scrollAnimation: GALLERY_CONSTS.scrollAnimations.NO_EFFECT,
  titlePlacement: function titlePlacement(sp) {
    return GALLERY_CONSTS.isVerticalPlacement(sp.titlePlacement) || sp.hoveringBehaviour === GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW;
  },
  imageHoverAnimation: GALLERY_CONSTS.imageHoverAnimations.NO_EFFECT,
  loveButton: false,
  loveCounter: false,
  allowDownload: false,
  allowSocial: false,
  isAccessible: false
};